import { Component, Host, h } from '@stencil/core';
import { environment } from '../../global/resources';

@Component({
  tag: 'mo-powerpay',
  styleUrl: 'mo-powerpay.css',
  shadow: true,
})
export class MoPowerpay {
  public urlBase: string = environment.base_url;

  render() {
    return (
      <Host>
        <div class='mo-powerpay'>
          <img
            src={`${this.urlBase}/assets/powerpay_white-blue.svg`}
            alt='Powerpay Logo'
          />
        </div>
      </Host>
    );
  }
}
